.formLabelContainer {
  display: flex;
  flex-direction: column;
  gap: var(--ism-spacing-2xs);
  margin-bottom: var(--ism-spacing-xs);
}

.formLabelContainer[aria-disabled="true"] {
  opacity: 0.5;
}

.formLabel {
  color: var(--ism-color-on-surface);
  font-family: var(--ism-typeface-bold);
  font-size: var(--ism-font-size-body-s);
}

.formDescription {
  color: var(--ism-color-on-surface-variant);
  font-size: var(--ism-font-size-body-s);
}
